import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { Image } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import moment from 'moment';

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: '',
			accessor: 'lesson.grade',
			cell: (grade, payment) => <span>{grade && grade.imageUrl && <Image thumbnail width={64} height={64} src={grade.imageUrl} alt={grade.name} />}</span>,
			className: 'purple'
		},
		{
			header: t('FO_Payment_Child'),
			accessor: 'child.shortName'
		},
		{
			header: t('FO_Payment_Center'),
			accessor: 'lesson.center.name'
		},
		{
			header: t('FO_Payment_Description'),
			accessor: 'paymentType',
			cell: paymentType => t(`PaymentTypeEnum_${paymentType}`)
		},
		{
			header: t('FO_Payment_Created'),
			accessor: 'created',
			cell: created => moment(created).format('lll')
		},
		{
			header: '',
			accessor: 'id',
			cell: (id, payment) => <Link to={`/enrolments/${id}`}>{t('FO_Payment_Details')}</Link>
		}
	];

	return (
		<div>
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

List.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		child: PropTypes.shape({
			shortName: PropTypes.string
		}),
		center: PropTypes.shape({
			name: PropTypes.string
		}),
		startDate: PropTypes.string,
		created: PropTypes.string
	}))
};

export default withTranslation()(List);